import React from "react";
import {
	Box,
	Typography,
	Button,
	Stack,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@mui/material";
import { InfoRounded } from "@mui/icons-material";
import { Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
	setComplianceChecked,
	submitSuccessfully,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import {
	handleReset,
	handleCompleteStep,
} from "../../redux/slices/addNewContentStepsSlice";
import { useDispatch } from "react-redux";

const ContentSuccessModal = ({ open, onClose, formik }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Note</DialogTitle>
			<DialogContent>
				<Typography>
					Your content is under review by DreamStream licensing &
					acquisition team. Once approved the content will be rendered
					in 48 hours to the viewers. Thankyou !
				</Typography>
				<Stack my={1} direction={"row"} alignItems={"center"}>
					<Info />
					<Typography ml={1} variant="h5">
						Disclaimer
					</Typography>
				</Stack>

				<Typography ml={4} color={"primary.light"} fontSize={"14px"}>
					If there is any observation in the content review process
					the file will be returned for rectification and
					re-submission.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						dispatch(submitSuccessfully(false));
						dispatch(setComplianceChecked(false));
						dispatch(handleReset());
						formik.resetForm();
						dispatch(handleCompleteStep(0));
						dispatch(handleCompleteStep(1));
					}}
					variant="contained"
					sx={{
						backgroundColor: "primary.dark",
						color: "secondary.main",
						textTransform: "capitalize",
					}}
				>
					Upload another content
				</Button>
				<Button
					onClick={() => {
						dispatch(submitSuccessfully(false));
						dispatch(handleReset());
						formik.resetForm();
						navigate("/content");
					}}
					variant="contained"
					sx={{
						backgroundColor: "primary.dark",
						color: "secondary.main",
						textTransform: "capitalize",
						fontWeight: "normal",
					}}
				>
					Finish
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ContentSuccessModal;
